<template>
  <a class="btn btn-plain position-relative"
     v-if="wazzupEnabled && userHasAccessToWazzup"
     @click="wazzupChat">
    <WazzupSvg class="svg-wazzup"/>
    <span class="notification-bubble"
          v-b-tooltip.hover
          :title="counter"
          v-if="counter > 0">{{ counter }}</span>
    <WazzupIframeModal/>
  </a>
</template>

<script setup>
import WazzupSvg from '@/assets/svg-vue/crm/whatsapp.svg'
import { WhatsappService } from "@/services/api/whatsapp.api.service"
// import ApiService, {WhatsappService} from "@/services/api.service"
import WazzupIframeModal from "@/components/parts/settings/WazzupIframeModal"
import { computed, getCurrentInstance, nextTick, onMounted, ref } from "vue"
import { useStore } from "vuex"

const store = useStore()
const instance = getCurrentInstance()
const noty = instance?.appContext?.app?.noty
const bvModal = instance?.proxy?.$bvModal

// the unread messages
const counter = ref(0)

const wazzupEnabled = computed(() => store.state.crm.wazzupEnabled)
const user = computed(() => store.state.auth.user)
const superadmin = computed(() => store.state.auth.superadmin)
const dynamicConfigValue = computed(() => store.getters.dynamicConfigValue)
const wazzupUsers = computed(() => dynamicConfigValue.value('wazzupUsers') || [])
const userHasAccessToWazzup = computed(() => (wazzupUsers.value.includes(user.value.id)))

const wazzupChat = async () => {
  let res = await WhatsappService.createIframe()
  if (res.data.url) {
    store.commit('setWazzupIframeUrl', res.data.url)
    nextTick(() => {
      bvModal.show('wazzup-iframe-modal')
    })
    return
  }
  if (res.data.error) {
    noty.error(res.data.error)
  }
}

const socket = async () => { // used to get unread messages through socket
  try {
    const res = await WhatsappService.getWazzupSocketCredentials()
    if(res && res.data && res.data.user && res.data.key) {
      const wsHost = 'ws-counters2.wazzup24.com'
      const connectOptions = {
        path: '/ws-counters/',
        transports: ['websocket', 'polling']
      }
      const apiKey = res.data.key
      const userId = res.data.user.id
      const client = window.io(`https://${wsHost}`, connectOptions)
      client.on('connect', () => {
        console.log('socket connected')
        client.emit('counterConnecting', {
          type: 'api_v3',
          apiKey,
          userId
        })
      })
      client.on('counterConnected', () => console.log('Connected to Wazzup notifications!'))
      client.on('counterUpdate', (data) => {
        console.log('wazzup counter updated', data)
        counter.value = data.counter
      })
    }
  } catch (e) {
    console.log(e)
  }
}

const getWazzupStatus = () => {
  WhatsappService.getWazzupStatus(superadmin.value).then(res => {
    store.commit('setWazzupEnabled', res.data)
    if(res.data) {
      setTimeout(() => {
        socket()
      }, 4000)
    }
  })
}

onMounted(async () => {
  if(userHasAccessToWazzup.value) {
    try {
      await getWazzupStatus()
    } catch (error) {
      console.log(error)
    }
  }
})
</script>

<style scoped>
.svg-wazzup {
  fill: #BAC0C6;
  width: 18px;
}
.notification-bubble {
  top: -2px;
}
</style>
